import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { IDocumentosEmitidos } from 'src/app/interface/interfaces';
import { SenaceService } from 'src/app/services/senace.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-tab-documentos-emitidos',
  templateUrl: './tab-documentos-emitidos.component.html',
  styleUrls: ['./tab-documentos-emitidos.component.css']
})
export class TabDocumentosEmitidosComponent implements OnInit {
  documentos: IDocumentosEmitidos[] = [];

  constructor(
    private localStorage: LocalStorage,
    private senaceService: SenaceService
  ) { }

  ngOnInit() {
    this.localStorage.getItem('detalle')
      .subscribe(
        resp => {
          this.getDocumentos(resp['correlativo']);
        }
      )
  }

  getDocumento(id: string) {
    return this.senaceService.getDocumentoAlfresco(id);
  }

  private getDocumentos(expediente: string) {
    Swal.fire({
      text: 'Consultando documentos emitidos ...',
      icon: 'info',
      showCancelButton: false
    });
    Swal.showLoading();
    this.senaceService.getDocumentosEmitidos(expediente)
      .subscribe(
        (response) => {
          Swal.close();
          this.documentos = response;
        }, (error) => {
          Swal.fire({
            title: 'Aviso',
            text: 'Error al consultar el expediente. Intente nuevamente',
            icon: 'error',
            confirmButtonText: 'Aceptar'
          })
        }
      )
  }

}
